import React, { useState } from 'react';
import { Box, Button, Modal, Text } from '@nimbus-ds/components';
import { Country } from 'App/i18n/enums';
import { useCountry, useFeatureDiscovery } from 'commons/hooks';
import { FeatureName } from 'commons/services/featureDiscoveryService/featureDiscoveryServiceResponses';
import { useTranslationWithPrefix } from 'commons/utils';

interface FeatureDiscoveryModalProps {
  featureName: FeatureName;
  title: string;
  description: string;
  forCountries?: Country[];
}

function FeatureDiscoveryModal({
  featureName,
  title,
  description,
  forCountries,
}: FeatureDiscoveryModalProps): JSX.Element {
  const { t } = useTranslationWithPrefix('commons.featureDiscoveryModal');
  const featureDiscovery = useFeatureDiscovery(featureName);
  const [modalDismissed, setModalDismissed] = useState(false);
  const { storeCountry } = useCountry();

  const modalOpen =
    !featureDiscovery.isLoading &&
    !featureDiscovery?.isDiscovered &&
    !modalDismissed &&
    (!forCountries || forCountries.includes(storeCountry));

  const handleOnDismiss = () => {
    featureDiscovery.markAsDiscovered.mutate();
    setModalDismissed(true);
  };

  return (
    <Modal open={modalOpen} onDismiss={handleOnDismiss}>
      <Modal.Header title={title} />
      <Box alignItems="stretch">
        <Text color="neutral-textHigh">{description}</Text>
      </Box>
      <Modal.Footer>
        <Button
          appearance="primary"
          onClick={handleOnDismiss}
          disabled={featureDiscovery.isMutating}
        >
          {t('understood')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default FeatureDiscoveryModal;
